import { Component, h, Host, Prop, Watch } from "@stencil/core";

import { Font } from "../../index";

/**
 * @slot - Text content
 */
@Component({
  tag: "stzh-heading",
  styleUrl: "stzh-heading.scss",
  scoped: true,
})
export class StzhHeading {
  /** Heading level */
  @Prop({ reflect: true }) level: "1" | "2" | "3" | "4" = "2";

  /** Type of curve to overwrite the curve inherited from `level` attribute (see [Spacings docs page](/docs/tokens-typography--docs#curves) for more info). */
  @Prop({ reflect: true }) curve: Font.Curves | "auto" = "auto";

  /* HTML content (since innerHTML won't work when it's being changed after initial render) */
  @Prop() htmlContent: string;
  private _htmlContent: string = "";

  @Watch("htmlContent")
  htmlContentWatcher(newValue: string) {
    this._htmlContent = newValue;
  }

  componentWillLoad() {
    this.htmlContentWatcher(this.htmlContent);
  }

  render() {
    const Heading = `h${this.level}`;
    const classes = {
      "stzh-heading": true,
      [`stzh-heading--level-${this.level}`]: !!this.level,
      [`stzh-heading--curve-${this.curve}`]: !!this.curve,
    };

    return (
      <Host>
        <Heading class={classes}>
          <slot></slot>
          {this._htmlContent && <div innerHTML={this._htmlContent}></div>}
        </Heading>
      </Host>
    );
  }
}
